<div class="numeric-keyboard"
     [class.disabled]="disabled">
  <!-- Numeric pad -->
  <div class="numeric-pad">
    <ion-row *ngIf="!useForWeighingOutput">
      <ion-col>
        <ng-container *ngIf="secure; else notSecure">
          <span class="secure"
                [innerHTML]="digits.join('') | password"></span>
        </ng-container>
        <ng-template #notSecure>
          <span *ngIf="!allowCurrency; else currencyView">{{ digits.join('') }}</span>

          <ng-template #currencyView>
            <span>{{digits.join('') | negative: negativeValues | currency}}</span>
          </ng-template>
        </ng-template>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col [id]="'number-pad-' + digit"
               size="4"
               *ngFor="let digit of ALLOWED_DIGITS"
               debounce-click
               [debounceTime]="0"
               (debounceClick)="add(digit)"
               [class.clickable]="allowKeyboardInput">
        <span>{{digit}}</span>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4"
               [class.clickable]="allowDecimals && allowKeyboardInput"
               debounce-click
               [debounceTime]="0"
               (debounceClick)="add('.')">
        <span *ngIf="allowDecimals">.</span>
      </ion-col>
      <ion-col size="4"
               debounce-click
               [debounceTime]="0"
               (debounceClick)="add('0')"
               [class.clickable]="allowKeyboardInput">
        <span>0</span>
      </ion-col>
      <ion-col size="4"
               [class.clickable]="digits?.length && allowKeyboardInput"
               debounce-click
               [debounceTime]="0"
               (debounceClick)="remove()">
        <img src="assets/image/shared/backspace.png" />
      </ion-col>
    </ion-row>
    <ng-content select="[custom-number-pad]"></ng-content>
  </div>
</div>

<div class="action-buttons"
     *ngIf="buttons?.length">
  <ng-container *ngFor="let button of buttons">
    <ng-container [ngSwitch]="button">
      <ng-container *ngSwitchCase="'submit'"
                    [ngTemplateOutlet]="submitBtn"></ng-container>
      <ng-container *ngSwitchCase="'cancel'"
                    [ngTemplateOutlet]="cancelBtn"></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #submitBtn>
  <ion-button mode="md"
              class="ion-no-margin"
              color="dark"
              size="large"
              expand="full"
              strong="true"
              [disabled]="(minLength && digits?.length < minLength) || (!minLength && !digits?.length) || !allowKeyboardSubmit"
              debounce-click
              [debounceTime]="0"
              (debounceClick)="submit()">Submit</ion-button>
</ng-template>

<ng-template #cancelBtn>
  <ion-button mode="md"
              class="ion-no-margin"
              color="light"
              size="large"
              expand="full"
              debounce-click
              [debounceTime]="0"
              (debounceClick)="cancel()">Cancel</ion-button>
</ng-template>
